// extracted by mini-css-extract-plugin
export default {"error-msg":"NotFound_styles__error-msg___c0","oversized":"NotFound_styles__oversized___a5","timer":"NotFound_styles__timer___c1","loading":"NotFound_styles__loading___f5"};